import { Link } from "preact-router/match";
import { useContext, useEffect, useLayoutEffect, useState } from "preact/hooks";
import { Fragment } from "preact";

import { Splide } from '@splidejs/splide';

import { BoatContext } from "../app.context";
import { LanguageContext, t } from "./language";

import { Boat } from "../services/requests";
import { getThemePath } from "../utils";
import clsx from "clsx";

import '@splidejs/splide/css';

const DEFAULT_BOAT: Boat = {
  count: "10",
  licence: false,
  promo: 0,
  slug: "default-boat",
  speed: "200",
  title: "Ladowanie lodzi",
  content: "Ladowanie lodzi",
  pricing: [
    {
      time: "1 godzina z paliwem",
      price: "-",
    },
  ],
  gallery: [],
};

export const Modal = (props: { path: string }) => {
  const [lang] = useContext(LanguageContext);
  const boat = useContext(BoatContext) || DEFAULT_BOAT;
  const [selectedTime, setSelectedTime] = useState<string | undefined>();

  useEffect(() => {
    document.body.classList.add("lock");

    return () => {
      document.body.classList.remove("lock");
    };
  });

  useEffect(() => {
    setSelectedTime(boat?.pricing?.[0].price);
  }, [boat]);

  const onTimeSelect = (event: any) => {
    setSelectedTime(event.target.value);
  };

  useLayoutEffect(( ) => {
    const mainSplide = new Splide('#main-carousel', {
      type: 'loop',
      height: 520,
      rewind: true,
      pagination: false,
      arrows: true,
    })

    const thumbanilsSplide = new Splide( '#thumbnail-carousel', {
      fixedWidth : 100,
      fixedHeight: 80,
      gap: 0,
      rewind: true,
      pagination: false,
      arrows: false,
    })

    mainSplide.sync( thumbanilsSplide );
    mainSplide.mount();
    thumbanilsSplide.mount();

  }, []);

  return (
    <div className="modal">
      <div className="modal-container flex flex-col md:flex-row md:block">
        <header className="mobile-header">
          {/* @ts-ignore */}
          <Link href="/">
            <img
              src={getThemePath("/images/logo_mobile.png")}
              alt="Szekla"
              className="mobile"
            />
          </Link>
        </header>
        {/* @ts-ignore */}
        <Link className="close" href="/">
          ×
        </Link>

        <div className="row h-full flex flex-col md:flex-row">
          <div className="col-xlg-7 col-lg-7 col-md-7 col-sm-12 col-xs-12 p-0">
            <section
              id="main-carousel"
              className="splide"
              aria-label="The carousel with thumbnails. Selecting a thumbnail will change the Beautiful Gallery carousel."
            >
              <div className="splide__track">
                <ul className="splide__list">
                  {boat?.gallery.map((item) => (
                    <li className="splide__slide">
                      <img src={item.large} className="image-fit" loading="lazy" />
                    </li>
                  ))}
                </ul>
              </div>
            </section>

            <section
              id="thumbnail-carousel"
              className="splide"
              aria-label="The carousel with thumbnails. Selecting a thumbnail will change the Beautiful Gallery carousel."
            >
              <div className="splide__track">
                <ul className="splide__list">
                  {boat?.gallery.map((item) => (
                  <li className="splide__slide">
                    <img src={item.large} className="image-fit" loading="lazy" />
                  </li>
                  ))}
                </ul>
              </div>
            </section>
          </div>

          {/* right side */}
          <div className="col-xlg-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 flex flex-col md:h-full flex-1">
            <h4 className={clsx({ "text-red": boat.promo })}>{boat?.title}</h4>
            <div
              className="content flex-1"
              dangerouslySetInnerHTML={{
                __html: boat?.content ?? "",
              }}
            />

            {!boat?.promo && (
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-6 col-xs-6">
                  <select className="rental" onChange={onTimeSelect}>
                    {Object.values(boat?.pricing ?? {}).map((data) => (
                      <option value={data.price}>{data.time}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                  <div className="price">
                    <p>{t("main_price")}:</p>
                    <small>{selectedTime} PLN</small>
                  </div>
                </div>
              </div>
            )}

            <div className="row desc">
              {!boat?.promo && (
                <Fragment>
                  <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 details separator br-1">
                    <div className="flex flex-col justify-center items-center info-box">
                      <img
                        src={getThemePath("/images/osoby.svg")}
                        alt="Ilość osób"
                        width={40}
                      />
                      <span>
                        {boat?.count} {t("main_people")}
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 details separator br-1">
                    <div className="flex flex-col justify-center items-center info-box">
                      <img
                        src={getThemePath("/images/silnik.svg")}
                        alt="Ilość osób"
                        width={40}
                      />
                      <span>{boat?.speed} KM</span>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 details separator">
                    <div className="flex flex-col justify-center items-center info-box">
                      <img
                        src={getThemePath("/images/uprawnienia.svg")}
                        alt="Ilość osób"
                        width={40}
                      />
                      <span>
                        {Boolean(boat?.licence)
                          ? t("no_licence")
                          : t("licence")}
                      </span>
                    </div>
                  </div>
                </Fragment>
              )}
              <div className="col-sm-12 col-xs-12 hide-lg hide-md">
                <a href="tel:880045779" className="btn-phone">
                  Zadzwoń!
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
